import { ISMOBILE } from "@/utils/utils.js";

const state = {
  isMobile: false,
}

const mutations = {
  setDeciveMode: (state, isMobile) => {
    state.isMobile = isMobile
    console.log('当前模式', state.isMobile ? '移动端' : 'PC端');
  }
};

const actions = {
    checkDeviceMode({ commit }) {
        commit('setDeciveMode', ISMOBILE())
    }
}

export default {
    state,
    mutations,
    actions
};